import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import Main from "../../components/main";
import history from "../../shared/history";
import {useOsano} from "../../hooks/useOsano";
import {useAmplitude} from "../../hooks/useAmplitude";
import { datadogRum } from "@datadog/browser-rum-slim";

const initDatadogRum = () => {
  const baseUrl = new URL(`https://${window.location.hostname}`);
  const proxyUrl = new URL(`${baseUrl}/client-rum`);
  const clientToken = window.DATADOG_RUM_TOKEN;

  datadogRum.init({
    applicationId: '06fff118-db5d-4031-8063-673a080a8724',
    clientToken,
    site: "datadoghq.com",
    service: "universal-login",
    env: process.env.AWS_ENV,
    trackUserInteractions: true,
    trackFrustrations: true,
    trackResources: true,
    trackLongTasks: true,
    sampleRate: 100,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    useSecureSessionCookie: true,
    proxyUrl: proxyUrl,
    allowedTracingOrigins: [baseUrl.origin],
    traceSampleRate: 100,
    defaultPrivacyLevel: "mask-user-input"
  });
};
export const App = () => {
  const {isOsanoAnalyticsAllowed} = useOsano();
  useAmplitude({
      apiKey: window.AMPLITUDE_API_KEY,
      apiDomain: window.AMPLITUDE_API_DOMAIN,
      shouldOptOut: !isOsanoAnalyticsAllowed
  });
  initDatadogRum();

  return (
    <Router history={history}>
      <Switch>
        <Route path="/" exact />
      </Switch>
      <Main />
    </Router>
  );
};

export default App;
